import { AppDispatch, createAction } from '@reduxjs/toolkit';
import { IVacancyFilters } from 'types/filters/vacancies';

export const CHANGE_VACANCY_FILTERS = createAction<IVacancyFilters, string>('vacancies/CHANGE_VACANCY_FILTERS');

export const changeVacancyFilters = (vacancyFilter: IVacancyFilters) => (dispatch: AppDispatch) => {
  dispatch(CHANGE_VACANCY_FILTERS(vacancyFilter));
};
